import * as Yup from 'yup';
 
export const ValidationSchema = (id) =>
  Yup.object({
    first_name: Yup.string().required('First name is required'),
    last_name: Yup.string().required('Last name is required'),
    role: Yup.string().required('Role is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    password: id
      ? Yup.string().notRequired() 
      : Yup.string().min(6, 'Password must be at least 6 characters').required('Password is required'),
  });
